//states/login.js
import { make } from "vuex-pathify"
import axiosInstances from '../server/axiosInstances'

const state = {
  loggedIn: false,
  loginDialog: true,
  changePWDialog: false,
  loggedinUser: {},
  loggedinOrg: {},
  origLoggedinUser: {},
  origLoggedinOrg: {},
  loginFailed: false,
  loginActions: null,
  loginWelcomeBackground: null,
  loginDialogBackground: null,
  loginMenuItems: [],
  loginError: null,
  facility: null,
  loginMessage: null,
  initialLoginComplete: false,
  fullScreen: false,
  loader: {}
};

const mutations = make.mutations(state)

const actions = {
  async doLogin ({ commit }, credentials) {
    state.loginError = null
    let res, data
    state.initialLoginComplete = false
    try {
      res = await axiosInstances.loginServer.post('/auth/login', credentials)
      data = res.data
      state.origLoggedinUser = data
      state.loggedinUser = data
      state.initialLoginComplete = true
    } catch (ex) {
      console.log('ex is: ', ex)
      state.loginError = ex.message
      state.loginFailed = true
      return false
    }
    localStorage.setItem('origToken', data['x-access-token'])
    return true
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}